export const SET_SELECTED_PCP_LINE = "pcpSelection/SET_SELECTED_PCP_LINE";
export const SET_SELECTED_PCP_ROW = "pcpSelection/SET_SELECTED_PCP_ROW";
export const SET_SELECTED_PCP_LINE_INDEX =
  "pcpSelection/SET_SELECTED_PCP_LINE_INDEX";

export type PcpMode = "passive" | "active" | "offset";

export const setSelectedPcpLine = (mode: PcpMode, payload: number | null) => ({
  type: SET_SELECTED_PCP_LINE,
  payload: { mode, value: payload },
});

export const setSelectedPcpLineIndex = (
  mode: PcpMode,
  payload: number | null
) => ({
  type: SET_SELECTED_PCP_LINE_INDEX,
  payload: { mode, value: payload },
});

export const setSelectedPcpRow = (
  mode: PcpMode,
  payload: Record<string, any> | null
) => ({
  type: SET_SELECTED_PCP_ROW,
  payload: { mode, value: payload },
});

export type PcpSelectionActions =
  | ReturnType<typeof setSelectedPcpLine>
  | ReturnType<typeof setSelectedPcpRow>;
